import { SelectStatic } from '@product-framework/components/FormFields';
import { observer } from 'mobx-react';
import { forwardRef } from 'react';
import { useBatchFileImportContext } from './BatchFileImportPage/providers/BatchFileImportProvider';

const BatchFileImportStatusSelector = forwardRef((props, ref) => {
  const { statusOptions } = useBatchFileImportContext();

  return (
    <SelectStatic
      {...props}
      ref={ref}
      customConfig={{ options: statusOptions || [] }}
    />
  );
});

export default observer(BatchFileImportStatusSelector);
